import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject, ISafetyCaseEnumLookup } from '../../interfaces'

const getMitigationStatusesRequest = (): IGetRequestObject => ({
  method: 'get',
  url: `${config.baseUrl}/sms/Lookups/MitigationStatuses`,
})

const useSafetyCaseHazardMitigationStatusesQuery = buildGetQuery<undefined, undefined, ISafetyCaseEnumLookup[] | undefined>({
  getRequest: getMitigationStatusesRequest,
  getQueryKey: () => ['mitigation-statuses'],
})

export default useSafetyCaseHazardMitigationStatusesQuery
